import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; //useDispatch
//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import AddEquipmentModal from "./AddEquipmentModal";
import EquipmentDetails from "./EquipmentDetails";
import EquipmentListEditModal from "./EquipmentListEditModal";

const EquipmentList = () => {
  localStorage.setItem("menu", "Equipment Master ");
  localStorage.setItem("submenu", "Equipment");

  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.pagination
  );
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({});

  useEffect(() => {
    if (getDropdownData?.textField) {
      setSelectedCategory((prev) => ({
        ...prev,
        // [getDropdownData.textField]: getDropdownData.name.trim(), // ✅ trim spaces
        [getDropdownData.textField]: (getDropdownData.name || "").trim(),
      }));
    }
  }, [getDropdownData]);

  let Subcategory = [
    {
      id: "1",
      subCategory: "Oxygen Concentrators",
      name: "Oxygen Concentrators",
    },
    {
      id: "2",
      subCategory: "Ventilators",
      name: "Ventilators",
    },
    {
      id: "3",
      subCategory: "Walking Sticks",
      name: "Walking Sticks",
    },
    {
      id: "4",
      subCategory: "Crutches",
      name: "Crutches",
    },
    {
      id: "5",
      subCategory: "Posture Support",
      name: "Posture Support",
    },
  ];
  const handleSearchClick = () => {
    const selectedSubCategory = (selectedCategory?.category || "")
      .trim()
      .toLowerCase();
    // const selectedPrice = (selectedCategory?.price || "").trim();

    let filtered = data;

    if (selectedSubCategory) {
      filtered = filtered.filter((item) => {
        const subCat = item.info?.[0]?.subCategory?.toLowerCase().trim();
        return subCat === selectedSubCategory;
      });
    }

    // if (selectedPrice) {
    //   filtered = filtered.filter((item) => {
    //     const price = String(item.info?.[0]?.price || "").trim();
    //     return price === selectedPrice;
    //   });
    // }
    setFilteredProducts(filtered);
  };

  const handleRefresh = () => {
    setSelectedCategory({
      category: "",
      price: "",
      sortBy: "",
      subCategory: "",
    });
    setDropdownData({});
    setFilteredProducts(data);
  };

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  let CategorydropdownOptions = [
    {
      id: "1",
      name: "Oxygen Concentrators ",
    },
    {
      id: "2",
      name: "Ventilators",
    },
    {
      id: "3",
      name: "Walking Sticks ",
    },
    {
      id: "4",
      name: "Crutches ",
    },
    {
      id: "5",
      name: "Posture Support ",
    },
  ];
  let LineItemStatusdropdownOptions = [
    {
      id: "1",
      name: "Active",
    },
    {
      id: "2",
      name: "Pending",
    },
    {
      id: "3",
      name: "Sold Out",
    },
  ];

  let pricedropdownOptions = [
    {
      id: "1",
      name: "1000-2000",
    },
    {
      id: "2",
      name: "2000-3000",
    },
    {
      id: "3",
      name: "4000-8000",
    },
  ];
  const data = [
    {
      productName: "Oxymed 10 Liter Oxygen Concentrator",
      imageUrl: "assets/img/product_img/M1.jpg",
      info: [
        {
          id: 11,
          productNumber: "OXM10001",
          category: "Medical Equipment",
          subCategory: "Oxygen Concentrators",
          stock: 25,
          sold: 18,
          availableStock: 7,
          perMonth: 4300,
          views: 1200,
          price: 85000,
          discount: 10,
          discountedPrice: 76500,
          description:
            "High-flow 10L oxygen concentrator ideal for long-term oxygen therapy.",
          vendor: "Oxymed",
          vendorLocation: "Delhi, India",
          vendorEmail: "support@oxymed.in",
          vendorPhone: "+91-9876543210",
          serviceDate: "2025-06-15",
          serviceCompanyName: "Oxymed Service Pvt Ltd",
          serviceWarranty: "2 years",
          serviceType: "Annual Maintenance",
          serviceEngineer: "Rajesh Kumar",
          status: "Active",
          notes: "Next service due in June 2026",
          rating: 4.7,
          reviews: 48,
          weight: "27kg",
          dimensions: "68cm x 37cm x 39cm",
          color: "White",
          material: "ABS Plastic",
          careInstructions: "Keep in ventilated space, clean filters regularly",
          availability: "In Stock",
          createdAt: "2024-06-01",
          updatedAt: "2024-06-15",
          tags: ["oxygen", "therapy", "concentrator"],
          warranty: "2 years",
          returnPolicy: "Return within 15 days",
          shipping: {
            availableRegions: ["India", "UAE", "Europe"],
            estimatedDelivery: "3-7 business days",
            cost: "Free",
          },
          featured: true,
          seasonal: false,
          bestseller: true,
        },
      ],
    },
    {
      productName: "ResMed Astral 150 Ventilator APAC2",
      imageUrl: "assets/img/product_img/M2.jpg",
      info: [
        {
          id: 12,
          productNumber: "RMD15002",
          category: "Medical Equipment",
          subCategory: "Ventilators",
          stock: 10,
          sold: 5,
          availableStock: 5,
          perMonth: 4500,
          views: 950,
          price: 620000,
          discount: 8,
          discountedPrice: 570400,
          description:
            "Portable life support ventilator designed for both invasive and non-invasive care.",
          vendor: "ResMed",
          vendorLocation: "Sydney, Australia",
          vendorEmail: "contact@resmed.com.au",
          vendorPhone: "+61-412345678",
          serviceDate: "2025-06-20",
          serviceCompanyName: "ResMed Support Intl",
          serviceWarranty: "3 years",
          serviceType: "Bi-annual Service",
          serviceEngineer: "Emily Watson",
          status: "Active",
          notes: "Calibration needed every 6 months",
          rating: 4.9,
          reviews: 20,
          weight: "3.2kg",
          dimensions: "28cm x 21cm x 9cm",
          color: "Silver",
          material: "High-grade polymer",
          careInstructions: "Use with care, follow service intervals",
          availability: "In Stock",
          createdAt: "2024-06-05",
          updatedAt: "2024-06-18",
          tags: ["ventilator", "portable", "life support"],
          warranty: "3 years",
          returnPolicy: "Return within 7 days",
          shipping: {
            availableRegions: ["India", "USA", "Europe"],
            estimatedDelivery: "4-8 business days",
            cost: "Paid",
          },
          featured: true,
          seasonal: false,
          bestseller: false,
        },
      ],
    },
    {
      productName: "Monopad Walking Stick With Seat",
      imageUrl: "assets/img/product_img/M3.jpg",
      info: [
        {
          id: 13,
          productNumber: "MONO3001",
          category: "Mobility Aids",
          subCategory: "Walking Sticks",
          stock: 60,
          sold: 40,
          availableStock: 20,
          perMonth: 2500,
          views: 2300,
          price: 2200,
          discount: 5,
          discountedPrice: 2090,
          description:
            "Lightweight walking stick with an integrated foldable seat.",
          vendor: "Monopad",
          vendorLocation: "Mumbai, India",
          vendorEmail: "info@monopad.com",
          vendorPhone: "+91-9988776655",
          serviceDate: "2025-05-10",
          serviceCompanyName: "Monopad Mobility Services",
          serviceWarranty: "1 year",
          serviceType: "Inspection",
          serviceEngineer: "Karan Desai",
          status: "Active",
          notes: "Low wear and tear observed",
          rating: 4.4,
          reviews: 25,
          weight: "1.2kg",
          dimensions: "80cm x 30cm x 10cm",
          color: "Black",
          material: "Aluminum",
          careInstructions: "Wipe clean with dry cloth",
          availability: "In Stock",
          createdAt: "2024-05-15",
          updatedAt: "2024-06-01",
          tags: ["mobility", "stick", "seat"],
          warranty: "1 year",
          returnPolicy: "Return within 10 days",
          shipping: {
            availableRegions: ["India", "UK", "USA"],
            estimatedDelivery: "5-7 business days",
            cost: "Free",
          },
          featured: false,
          seasonal: false,
          bestseller: false,
        },
      ],
    },
    {
      productName: "Rebotec Elbow Crutch Child - Yellow",
      imageUrl: "assets/img/product_img/M4.jpg",
      info: [
        {
          id: 14,
          productNumber: "RBT2001",
          category: "Mobility Aids",
          subCategory: "Crutches",
          stock: 30,
          sold: 20,
          availableStock: 10,
          perMonth: 3500,
          views: 1800,
          price: 3500,
          discount: 10,
          discountedPrice: 3150,
          description:
            "Colorful and ergonomic elbow crutch designed for children.",
          vendor: "Rebotec",
          vendorLocation: "Germany",
          vendorEmail: "help@rebotec.de",
          vendorPhone: "+49-123456789",
          serviceDate: "2025-04-05",
          serviceCompanyName: "Rebotec TechCare",
          serviceWarranty: "1 year",
          serviceType: "General Checkup",
          serviceEngineer: "Lukas Schmidt",
          status: "Active",
          notes: "No issues found during last service",
          rating: 4.6,
          reviews: 32,
          weight: "800g",
          dimensions: "70cm x 18cm x 5cm",
          color: "Yellow",
          material: "Plastic and aluminum",
          careInstructions: "Clean with mild soap and water",
          availability: "In Stock",
          createdAt: "2024-04-20",
          updatedAt: "2024-05-10",
          tags: ["crutch", "children", "mobility"],
          warranty: "1 year",
          returnPolicy: "Return within 15 days",
          shipping: {
            availableRegions: ["Europe", "India", "Australia"],
            estimatedDelivery: "4-6 business days",
            cost: "Free",
          },
          featured: true,
          seasonal: false,
          bestseller: false,
        },
      ],
    },
    {
      productName: "Amron Xamax Backrest",
      imageUrl: "assets/img/product_img/M5.gif",
      info: [
        {
          id: 15,
          productNumber: "AMX9001",
          category: "Wellness",
          subCategory: "Posture Support",
          stock: 100,
          sold: 75,
          availableStock: 25,
          perMonth: 2800,
          views: 2700,
          price: 2900,
          discount: 15,
          discountedPrice: 2465,
          description:
            "Orthopedic backrest for spine support during long sitting hours.",
          vendor: "Amron Xamax",
          vendorLocation: "Bangalore, India",
          vendorEmail: "care@amronxamax.com",
          vendorPhone: "+91-9123456780",
          serviceDate: "2025-03-12",
          serviceCompanyName: "Xamax Care Services",
          serviceWarranty: "6 months",
          serviceType: "Post-sale Support",
          serviceEngineer: "Sneha Rao",
          status: "Active",
          notes: "Customer satisfied with support",
          rating: 4.5,
          reviews: 55,
          weight: "1kg",
          dimensions: "45cm x 40cm x 10cm",
          color: "Grey",
          material: "High-density foam and mesh",
          careInstructions: "Spot clean only",
          availability: "In Stock",
          createdAt: "2024-03-30",
          updatedAt: "2024-04-10",
          tags: ["backrest", "posture", "orthopedic"],
          warranty: "6 months",
          returnPolicy: "Return within 15 days",
          shipping: {
            availableRegions: ["India", "UAE", "UK"],
            estimatedDelivery: "3-6 business days",
            cost: "Free",
          },
          featured: false,
          seasonal: false,
          bestseller: true,
        },
      ],
    },
  ];
  const [modalShowEditProduct, setModalShowEditProduct] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);
  const [editEquipmentData, setEditEquipmentData] = useState(null);

  const showEditProduct = (data) => {
    setEditEquipmentData(data);
    setModalShowEditProduct(true);
  };
  const showAddProduct = () => {
    setModalShowAddProduct(true);
  };

  const hideModal = () => {
    setModalShowEditProduct(false);
    setModalShowAddProduct(false);
    setModalShowDetailProduct(false);
  };

  const [equipmentData, setEquipmentData] = useState(null);

  const equipmentDetails = (data) => {
    setEquipmentData(data);
    setModalShowDetailProduct(true);
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Equipment Details");
    setItemLevelModalShow(true);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  const lineItemColInfo = [
    {
      name: "Description",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.description} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Stock",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.stock} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Rented",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.sold} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Available Stock",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.availableStock} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Price",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.price} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Rating",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.rating} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Warranty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.warranty} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
  ];

  const columns = [
    {
      name: "Product Name",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="d-flex justify-content-center align-items-center cursor-pointer"
          onClick={() => equipmentDetails(row)}
        >
          <img
            src={row.imageUrl}
            alt="Profile"
            className="profileImageCss p-1"
            style={{ width: "60px" }}
          />
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row.productName} </p>
            <p className="m-0 p-0 pt-1">{row.productNumber} </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "400px",
    },
    {
      name: "Details",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px", cursor: "pointer" }}
            onClick={() => lineItemShowModal(row.info)}
          >
            <i className="bi bi-eye fs-4"></i>
          </span>
        </>
      ),
      width: "120px",
    },

    {
      name: "Purchase Unit Price",
      selector: (row) => row.info?.[0]?.price || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            ₹{row.info?.[0]?.price?.toLocaleString() || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Stock",
      selector: (row) => row.stock || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.info?.[0]?.stock} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Rented",
      selector: (row) => row.sold || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.info?.[0]?.sold} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Price Per Month",
      selector: (row) => row.perMonth || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.info?.[0]?.perMonth} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Available Stock",
      selector: (row) => row.availableStock || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.info?.[0]?.availableStock} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <ComboboxField
            label=""
            placeholder="Please select the status"
            data={LineItemStatusdropdownOptions}
            id="category"
            iconClassName="dropdownIcon"
            // className="z-9"
            name="category"
            code="categorycode"
            description="countryDesc"
            //   setValue={formInputs.country}
            // getvalue={setDropdownData}
          />
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Action",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            className="btn d-flex align-items-center w-100"
            onClick={() => showEditProduct(row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            <sapn className="m-0 p-0 pt-1">Edit </sapn>
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button class="btn btn-danger">
            <i class="bi bi-trash3"></i>
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Equipment </h2>
            <p className="subText">Equipment </p>
            <hr />
            {/* filter */}

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">AF</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Advanced Filter</span>
                        <span className="subHeaderTitle">Advanced Filter</span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding mt-4"
                        >
                          <SearchField
                            name="searchKey"
                            // value={getCommonSearchTxt}
                            // onChange={(event) =>
                            //   setCommonSearchTxt(event.target.value)
                            // }
                            // onClick={() => handleSearchFuncApi()}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Equipments"
                            placeholder="Please select the Category"
                            data={CategorydropdownOptions}
                            id="category"
                            iconClassName="dropdownIcon"
                            name="category"
                            code="categorycode"
                            description="countryDesc"
                            setValue={selectedCategory?.category}
                            getvalue={setDropdownData}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Sort by"
                            placeholder="Please select the Category"
                            data={CategorydropdownOptions}
                            id="sortBy"
                            iconClassName="dropdownIcon"
                            name="sortBy"
                            code="sortBycode"
                            description="countryDesc"
                            setValue={selectedCategory.sortBy}
                            getvalue={setDropdownData}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Sub Category"
                            placeholder="Please select the Category"
                            data={Subcategory}
                            id="subCategory"
                            iconClassName="dropdownIcon"
                            name="subCategory"
                            code="subCategoryCode"
                            description="subCategoryDesc"
                            setValue={selectedCategory.subCategory}
                            getvalue={setDropdownData}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Price"
                            placeholder="Please select the Category"
                            data={pricedropdownOptions}
                            id="price"
                            iconClassName="dropdownIcon"
                            name="price"
                            code="pricecode"
                            description="priceDesc"
                            setValue={selectedCategory?.price}
                            getvalue={setDropdownData}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={{ span: 2, offset: 8 }}
                          lg={{ span: 2, offset: 8 }}
                          className="commTopButtonRightLeftPadding"
                        >
                          <button
                            className="btnTable"
                            onClick={handleSearchClick}
                          >
                            Search
                          </button>
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <button className="btnTable" onClick={handleRefresh}>
                            Referesh
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">E</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Equipment</span>
                      <span className="subHeaderTitle">Equipment</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={showAddProduct}
                        >
                          <p className="m-0 me-2">Add Equipment</p>
                          <i class="bi bi-plus-square"></i>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={
                            filteredProducts.length > 0
                              ? filteredProducts
                              : data
                          }
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          //   onChangeRowsPerPage={handlePerRowsChange}
                          //   onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <EquipmentListEditModal
        show={modalShowEditProduct}
        onHide={() => hideModal()}
        equipmentData={editEquipmentData}
      />
      <AddEquipmentModal
        show={modalShowAddProduct}
        onHide={() => hideModal()}
      />
      <EquipmentDetails
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
        equipmentData={equipmentData}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default EquipmentList;
